import { render, staticRenderFns } from "./RoleAdd.vue?vue&type=template&id=e865fcac"
import script from "./RoleAdd.vue?vue&type=script&lang=ts"
export * from "./RoleAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports